module.exports = __webpack_public_path__ + "img/temperature_grey.db59ae26.svg";